import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import MusorForm from './MusorForm';
import MusorFilters from './MusorFilters';
import AlkalmakForm from './AlkalmakForm';
import AlkalomForm from './AlkalomForm';
import CsoportosForm from './CsoportosForm';
import JegyArForm from './JegyArForm';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import moment from 'moment';
import _ from 'lodash';
import RFForm from '../../../components/Form/RFForm';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../EsemenyekTooltips';
import TimeFormatter from '../../../commons/TimeFormatter';
import Lib from '../../../commons/lib';

const DEFAULT_ALKALOM = {
  teremkiosztasKod: '',
  teremkiosztasNev: '',
  terem: null,
  azonosito: '',
  esemenyKezdete: null,
  esemenyVege: null,
  foglalasKezdete: new Date(),
  foglalasVege: null,
  vasarlasKezdete: new Date(),
  vasarlasVege: null,
  foglalas: true,
  publikus: true,
  maxjegyszam: '10',
  kenyelmidij: '',
  kenyelmidijsz: '',
  rendelesIdoLimit: '',
  rendelesTorlesIdoLimit: '',
  tulajdonsag: null
};

class MusorContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: '',
      // ['NORMAL', 'DAYS']
      tableView: 'NORMAL',

      // ['LOAD', 'DATA', 'NETW']
      musorViewStatus: 'DATA',
      alkalomViewStatus: 'DATA',
      musorFormStatus: 'DATA',
      alkalomFormStatus: 'DATA',
      
      // DATA
      baseJson: [],
      baseJsonDays: {}, 
      alkalmakJson: [],
      jegyarakJson: [], 
      jegySelectJson: [],
      jegySelectArray: {},
      savedAlkalmak: [],
      expandedAlkalmak: [],
      jegyArTable: false,
      viewMusor: {},
      viewAlkalom: {},
      currentId: undefined,
      currentAlkalomId: undefined,
      currentJegyArId: undefined,
      torlesId: undefined,
      torlesAlkalomId: undefined,
      torlesJegyArId: undefined,
      selectedMusor: [],
      selectedAlkalom: [],
      selectedJegyek: {},
      esemenyTipusOptions: [],
      jegySWExists: false,

      // MUSOR FORM VALUES
      formEloadas: null,
      formHelyszin: null,
      formPublickezdete: null,
      formPublicvege: null,
      formAlkalmak: [DEFAULT_ALKALOM],

      // ALKALOM + CSOPORTOS FORM VALUES
      formEloadasIdotartam: 0, 
      formTeremkiosztasKod: '',
      formTeremkiosztasNev: '',
      formTerem: null,
      formTeremkiosztas: null,
      formAzonosito: '',
      formAllapot: '',
      formEsemenyKezdete: null,
      formEsemenyVege: null,
      formVasarlasKezdete: null,
      formVasarlasVege: null,
      formEsemenyTipus: null,
      formPublikus: null,
      formMaxjegyszam: '',
      formKenyelmidij: '',
      formKenyelmidijsz: '',
      formRendelesIdoLimit: '',
      formRendelesTorlesIdoLimit: '',
      formTulajdonsag: null,
      formPenznem: null,
      formKenyelmidijak: [],

      // CSOPORTOS PLUS VALUES 
      csoportDays: [],
      selectedDays: [],
      csoportosIdoOptions: [],
      formIdopontok: [],

      // JEGY FORM VALUES
      formJegy: null,
      formJegyarKategoria: null,
      formJegyar: '',

      // FILTER FORM VALUES
      formFilterEloadas: null,
      formFilterHelyszin: null,
      formFilterArchive: new Date(),

      // MODAL UTILS
      modalFormMusor: false,
      modalDoubleFormMusor: false,
      modalView: false,
      modalDelete: false,
      modalAlkalmak: false,
      modalAlkalomView: false,
      modalFormAlkalom: false,
      modalAlkalomDelete: false,
      modalJegyArDelete: false,
      modalCsoportos: false,
      modalJegySelect: false,
      modalFormJegyAr: false,
      deleteButtonLoading: false,
      deleteAlkalomButtonLoading: false,
      deleteJegyArButtonLoading: false,
      alkalomFormButtonLoading: false,
      alkalomAtadasButtonLoading: false,
      jegyArFormButtonLoading: false,
      alkalmakFormButtonLoading: false,
      jegySelectButtonLoading: false,
      filterButtonLoading: false,
    };
  }

  componentDidMount = () => {
    this.listHelyszin();
    this.listEloadas();
    this.listPenznem();
    this.getKenyelmiDijParam();
  }

  listKenyelmiDijak = async (helyszinId) => {
    Services.getKenyelmiDijByHelyszinId(helyszinId, (err, res) => {
      if (!err) {
        this.setState({ formKenyelmidijak: res[0] });
      }
    });
  }

  hasRole = (roles, checkKarb) => {
    return this.props.globals.hasRole(roles, checkKarb);
  }

  hasRoleSpec = (roles) => {
    return this.props.globals.hasRoleSpec(roles);
  }

  listHelyszin = () => {
    Services.listHelyszinSelect((err, res) => {
      if (!err) {
        this.setState({ helyszinOptions: res[0] });

        if(!this.state.formHelyszin && res[0].length === 1) {
          this.setState({ formHelyszin: res[0][0] })
        }
      }
    });
  }

  listEloadas = () => {
    Services.listEloadasok(null, (err, res) => {
      if (!err) {
        this.setState({ eloadasOptions: res[0] });
      }
    });
  }

  listPenznem = () => {
    Services.listAktivPenznem((err, res) => {
      if (!err) {
        this.setState({ penznemOptions: res[0] });
      }
    });
  }

  getKenyelmiDijParam = () => {
    Services.getKenyelmiDijParam((err, res) => {
      if (!err) {
        this.setState({ kenyelmiDijParam: res[0] == true });
      }
    });
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalFormMusor: !prevState.modalFormMusor }));
  }

  toggleDoubleFormModal = () => {
    this.setState(prevState => ({ modalDoubleFormMusor: !prevState.modalDoubleFormMusor }));
  }

  toggleFormAlkalomModal = () => {
    this.setState(prevState => ({ modalFormAlkalom: !prevState.modalFormAlkalom }));
  }

  toggleFormJegyArModal = () => {
    this.setState(prevState => ({ modalFormJegyAr: !prevState.modalFormJegyAr }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleDeleteAlkalomModal = () => {
    this.setState(prevState => ({ modalAlkalomDelete: !prevState.modalAlkalomDelete }));
  }

  toggleDeleteJegyArModal = () => {
    this.setState(prevState => ({ modalJegyArDelete: !prevState.modalJegyArDelete }));
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleViewAlkalomModal = () => {
    this.setState(prevState => ({ modalAlkalomView: !prevState.modalAlkalomView }));
  }
  
  toggleAlkalmakModal = () => {
    this.setState(prevState => ({ modalAlkalmak: !prevState.modalAlkalmak }));
  }

  toggleCsoportosModal = () => {
    this.setState(prevState => ({ modalCsoportos: !prevState.modalCsoportos }));
  }

  toggleJegySelectModal = () => {
    this.setState(prevState => ({ modalJegySelect: !prevState.modalJegySelect }));
  }

  onRowMusorSelect =  (musor) => {
    this.setState({ alkalmakJson: musor.alkalomEntities, jegyarakJson: [], selectedMusor: [musor.id] , currentId: musor.id, jegyArTable: false });
  }

  onRowAlkalomSelect =  (alkalom) => {
    this.setState({ jegyarakJson: alkalom.jegyarakEntityList, selectedAlkalom: [alkalom.id], currentAlkalomId: alkalom.id, currentAlkalomPenznemId: alkalom.penznemId, currentAlkalomPenznemAzon: alkalom.penznem?.azonosito, formTeremkiosztasKod: alkalom.teremkiosztasKod, jegyArTable: !!alkalom.id });
  }

  onRowJegySelect =  (jegy, isSelect) => {
    let selectedJegyek = Object.assign({}, this.state.selectedJegyek);
    if(isSelect){
      selectedJegyek[jegy.arkategoriaKod].push(jegy.nev);
    }else{
      selectedJegyek[jegy.arkategoriaKod] = selectedJegyek[jegy.arkategoriaKod].filter(x => x !== jegy.nev);
    }
    this.setState({ selectedJegyek });
  }

  onRowJegySelectAll = (isSelect, jegyek, e) => {
    let selectedJegyek = Object.assign({}, this.state.selectedJegyek);
    const arkategoriaKod = jegyek.map(j => j.arkategoriaKod)[0];
    selectedJegyek[arkategoriaKod] = isSelect ? jegyek.map(j => j.nev) : [];
    this.setState({ selectedJegyek });
  }

  handleTableLayoutChange = (tableView) => {
    this.setState(prevState => ({ selectedMusor: [], tableView : prevState.tableView == tableView ? 'NORMAL' : tableView}), () => this.listMusor());
  }

  listEsemenyTipus = () => {
    Services.listEsemenyTipus((err, res) => {
      if (!err) {
        this.setState({
          esemenyTipusOptions: res[0].map(e => { return {label: e.cap, value: e.cap}}),
        });
      }
    });
  }

  listMusor = () => {
    this.setState({
      tableStatus: 'LOAD',
      filterButtonLoading: true, 
      jegyArTable: false,
      alkalmakJson: [],
      jegyarakJson: [],
    }, () => {
      const listParam = {
        param: null,
        eloadasId: this.state.formFilterEloadas && this.state.formFilterEloadas.id,
        helyszinId: this.state.formFilterHelyszin && this.state.formFilterHelyszin.id,
        archive: this.state.formFilterArchive ?TimeFormatter.formatDate(this.state.formFilterArchive) : null, 
      }
      if(this.state.tableView === 'NORMAL'){
        Services.listMusor(listParam, (err, res) => {
          if (!err) {
            this.setState({
              tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
              baseJson: res[0],
              filterButtonLoading: false,
            }, async () => {
              Services.jegySWExists((err, res) => {
                if(!err){
                  this.setState({jegySWExists: res[0] == true});
                }
              });
              if(this.state.baseJson){
                await this.onRowMusorSelect(this.state.baseJson.find(m => m.id === this.state.currentId) || {});
              }
              if(this.state.alkalmakJson){
                await this.onRowAlkalomSelect(this.state.alkalmakJson.find(a => a.id === this.state.currentAlkalomId) || {});
              }
            });
          } else {
            this.setState({
              tableStatus: 'NETW',
              filterButtonLoading: false,
            });
          }
        });
      }else if(this.state.tableView === 'DAYS'){
        Services.listMusorGroupByNapok(listParam, (err, res) => {
          if (!err) {
            this.setState({
              tableStatus: res[0] != {} ? 'TABL' : 'DATA',
              baseJsonDays: res[0],
              filterButtonLoading: false,
            }, async () => {
              Services.jegySWExists((err, res) => {
                if(!err){
                  this.setState({jegySWExists: res[0] == true});
                }
              });
            });
          } else {
            this.setState({
              tableStatus: 'NETW',
              filterButtonLoading: false,
            });
          }
        });
      }
    });
  }

  getMusorView = (id) => {
    this.setState({
      musorViewStatus: 'LOAD',
    }, () => {
      Services.getMusor(id, (err, res) => {
        if (!err) {
          this.setState({
            viewMusor: res[0],
            musorViewStatus: 'DATA',
          });
        } else {
          this.setState({
            musorViewStatus: 'NETW'
          });
        }
      });
    });
  }

  getMusorForm = (id) => {
    this.setState({
      musorFormStatus: 'LOAD',
    }, () => {
      Services.getMusor(id, (err, res) => {
        if (!err) {
          this.setState({
            musorFormStatus: 'DATA',
            formEloadas: res[0].eloadas,
            formHelyszin: res[0].helyszin,
            formPublickezdete: res[0].publicKezdete,
            formPublicvege: res[0].publicVege,
            formAlkalmak: res[0].alkalomEntities,
          });
        } else {
          this.setState({
            musorFormStatus: 'NETW'
          });
        }
      });
    });
  }

  getAlkalomView = (id) => {
    this.setState({
      alkalomViewStatus: 'LOAD',
    }, () => {
      Services.getAlkalom(id, (err, res) => {
        if (!err) {
          this.setState({
            viewAlkalom: res[0],
            alkalomViewStatus: 'DATA',
          });
        } else {
          this.setState({
            alkalomViewStatus: 'NETW'
          });
        }
      });
    });
  }

  kenyelmiDijInputChecker = (e, v, tizedesjegy) => {
    if (e.key && /^[0-9\.,\-a-zA-Z]$/.test(e.key)) {
      v = v + e.key;
      tizedesjegy = tizedesjegy || 0;
      if (!new RegExp(`^\\d*\\.{0,${tizedesjegy}}\\d{0,${tizedesjegy}}$`).test(v))
        return false;
    }
    return true;
  }

  getAlkalomForm = (id) => {
    this.setState({
      alkalomFormStatus: 'LOAD',
    }, () => {
      Services.getAlkalom(id, (err, res) => {
        if (!err) {
          if (this.state.kenyelmiDijParam)
            this.listKenyelmiDijak(res[0].helyszinId);
          this.handleSelectInputChange(this.state.penznemOptions.find(penznem => res[0].penznemId == penznem.id), "formPenznem", true);
          this.setState({
            alkalomFormStatus: 'DATA',
            currentId: res[0].musorId,
            selectedMusor: [res[0].musorId],
            formTeremkiosztasKod: res[0].teremkiosztasKod,
            formTeremkiosztasNev: res[0].teremkiosztasNev,
            formTerem: res[0].terem,
            formTeremkiosztas: { kod: res[0].teremkiosztasKod, nev: res[0].teremkiosztasNev, teremId: res[0].teremId},
            formAzonosito: res[0].azonosito,
            formAllapot: res[0].allapot.caption,
            formEsemenyKezdete: res[0].esemenyKezdete,
            formEsemenyVege: res[0].esemenyVege,
            formFoglalasKezdete: res[0].foglalasKezdete,
            formFoglalasVege: res[0].foglalasVege,
            formVasarlasKezdete: res[0].vasarlasKezdete,
            formVasarlasVege: res[0].vasarlasVege,
            formEsemenyTipus: res[0].esemenyTipus,
            formPublikus: res[0].publikus,
            formMaxjegyszam: res[0].maxjegyszam,
            formKenyelmidij: res[0].kenyelmidij,
            formKenyelmidijsz: res[0].kenyelmidijsz,
            formRendelesIdoLimit: res[0].rendelesIdoLimit,
            formRendelesTorlesIdoLimit: res[0].rendelesTorlesIdoLimit,
            formTulajdonsag: res[0].tulajdonsagEntity,
            formHelyszin: { id: res[0].helyszinId },
            formKenyelmidij: res[0].kenyelmidij,
            formKenyelmidijsz: res[0].kenyelmidijsz
          }, async () => {
            const idotartam = await Services.getEloadasIdotartam(this.state.baseJson.find(m => m.id == this.state.currentId).eloadasId);
            this.setState({
              formEloadasIdotartam: idotartam,
            });
          });
        } else {
          this.setState({
            alkalomFormStatus: 'NETW'
          });
        }
      });
    });
  }

  getJegyArForm = (id) => {
    this.setState({
      jegyArFormStatus: 'LOAD',
    }, () => {
      Services.getJegyAr(id, (err, res) => {
        if (!err) {
          this.setState({
            jegyArFormStatus: 'DATA',
            formTeremkiosztasKod: res[0].teremkiosztasKod,
            formJegy: { id: res[0].jegyId, nev: res[0].jegy.nev, azonosito: res[0].jegy.azonosito},
            formJegyarKategoria: this.state.jegySWExists ? {cod: res[0].arkategoriaKod} :  res[0].arkategoriaKod,
            formJegyar: res[0].ar,
          });
        } else {
          this.setState({
            jegyArFormStatus: 'NETW'
          });
        }
      });
    });
  }

  deleteMusor = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteMusor(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listMusor();
        this.props.globals.addSuccess('Műsor törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  deleteAlkalom = () => {
    this.setState({
      deleteAlkalomButtonLoading: true
    });
    Services.deleteAlkalom(this.state.torlesAlkalomId, (err) => {
      if (!err) {
        this.toggleDeleteAlkalomModal();
        this.listMusor();
        this.props.globals.addSuccess('Alkalom törölve!');
        this.setState({
          deleteAlkalomButtonLoading: false
        });
      } else {
        this.setState({
          deleteAlkalomButtonLoading: false
        });
      }
    });
  }

  deleteJegyAr = () => {
    this.setState({
      deleteJegyArButtonLoading: true
    });
    Services.deleteJegyAr(this.state.torlesJegyArId, (err) => {
      if (!err) {
        this.toggleDeleteJegyArModal();
        this.listMusor();
        this.props.globals.addSuccess('Jegy ár törölve!');
        this.setState({
          deleteJegyArButtonLoading: false
        });
      } else {
        this.setState({
          deleteJegyArButtonLoading: false
        });
      }
    });
  }

  saveMusor = () => {
    const {
      currentId,
      formEloadas,
      formHelyszin,
      formPublickezdete,
      formPublicvege,
      formTypeMusor,
      formAlkalmak
    } = this.state;
    
    this.setState({
      saveButtonLoading: true
    }, () => {
      if (formTypeMusor == 'FEL') {
        let submitObj = {};
        submitObj.eloadasid = formEloadas && formEloadas.id;
        submitObj.helyszinid = formHelyszin && formHelyszin.id;
        submitObj.publickezdete =  formPublickezdete ? TimeFormatter.formatIso(formPublickezdete) : null;
        submitObj.publicvege =  formPublicvege ? TimeFormatter.formatIso(formPublicvege) : null;
  
        Services.addMusor(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Műsor felvéve!');
            this.toggleFormModal();
            this.listMusor();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      } else if(formTypeMusor == 'MOD') {
        let submitObj = {};

        submitObj.id = currentId;
        submitObj.eloadasid = formEloadas && formEloadas.id;
        submitObj.helyszinid = formHelyszin && formHelyszin.id;
        submitObj.publickezdete =  formPublickezdete ? TimeFormatter.formatIso(formPublickezdete) : null;
        submitObj.publicvege =  formPublicvege ? TimeFormatter.formatIso(formPublicvege) : null;
        submitObj.alkalomentities = formAlkalmak;
        
        Services.editMusor(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Műsor módosítva!');
            this.toggleFormModal();
            this.listMusor();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      }
    });
  }

  saveMusorAlkalmak = () => {
    const {
      formEloadas,
      formHelyszin,
      formPublickezdete,
      formPublicvege,
      formIdopontok,
      selectedDays,
      formTerem,
      formTeremkiosztas,
      formTulajdonsag,
      formPenznem,
      formEsemenyTipus,
      formPublikus,
      formMaxjegyszam,
      formKenyelmidij,
      formKenyelmidijsz,
      formRendelesIdoLimit,
      formRendelesTorlesIdoLimit,
      formEloadasIdotartam,
      jegySWExists
    } = this.state;

    const foglalhato = formEsemenyTipus ? formEsemenyTipus.nam.includes("FOGLALHATO") : false;
    const vasarolhato = formEsemenyTipus ? formEsemenyTipus.nam.includes("VASAROLHATO") : false;
    
    this.setState({
      saveButtonLoading: true
    }, () => {
      let submitObj = {};
      submitObj.eloadasid = formEloadas && formEloadas.id;
      submitObj.helyszinid = formHelyszin && formHelyszin.id;
      submitObj.publickezdete =  formPublickezdete ? TimeFormatter.formatIso(formPublickezdete) : null;
      submitObj.publicvege =  formPublicvege ? TimeFormatter.formatIso(formPublicvege) : null;

      Services.addMusor(submitObj, (err, res) => {
        if (!err) {
          this.props.globals.addSuccess('Műsor felvéve!');
          let submitObj = {};
          let alkalmak = [];

          selectedDays.forEach(day => {
            formIdopontok && formIdopontok.forEach(time => {
              const now = new Date();
              const dayParts = day.split('-');
              const timeParts = time.label.split(':');
              let kezdete = new Date(dayParts[0], dayParts[1] - 1, dayParts[2], timeParts[0], timeParts[1], 0);
              let vege = new Date(kezdete.getTime() + (formEloadasIdotartam * 60000));
              let vasarlasKezdete = now;
              let vasarlasVege = new Date(kezdete.getTime() - (10 * 60000));
              let foglalasKezdete = now;
              let foglalasVege = new Date(kezdete.getTime() - (30 * 60000));

              let alkalom = {};
              alkalom.teremkiosztasKod = jegySWExists ? formTeremkiosztas && formTeremkiosztas.kod : null;
              alkalom.teremkiosztasNev = jegySWExists ? formTeremkiosztas && formTeremkiosztas.nev : null;
              alkalom.teremId = !jegySWExists ? formTerem && formTerem.id : formTeremkiosztas ?  formTeremkiosztas.teremId : null;
              alkalom.esemenyTipus = formEsemenyTipus;
              alkalom.tulajdonsagEntity = formTulajdonsag;
              alkalom.penznemId = formPenznem?.id;
              alkalom.publikus = formPublikus;
              alkalom.maxjegyszam = formMaxjegyszam;
              alkalom.kenyelmidij = formKenyelmidij;
              alkalom.kenyelmidijsz = formKenyelmidijsz;
              alkalom.rendelesIdoLimit = formRendelesIdoLimit;
              alkalom.rendelesTorlesIdoLimit = formRendelesTorlesIdoLimit;

              alkalom.esemenyKezdete = TimeFormatter.formatIso(kezdete);
              alkalom.esemenyVege =  TimeFormatter.formatIso(vege);
              alkalom.foglalasKezdete = foglalhato ? TimeFormatter.formatIso(foglalasKezdete) : null;
              alkalom.foglalasVege =  foglalhato ? TimeFormatter.formatIso(foglalasVege) : null;
              alkalom.vasarlasKezdete =   vasarolhato ? TimeFormatter.formatIso(vasarlasKezdete) : null;
              alkalom.vasarlasVege = vasarolhato ? TimeFormatter.formatIso(vasarlasVege) : null;

              alkalmak.push(alkalom);
            });
          });

          const musor = res[0];
          submitObj.id = musor.id;
          submitObj.eloadasid = musor.eloadasId;
          submitObj.helyszinid = musor.helyszinId;
          submitObj.publickezdete =  musor.publicKezdete;
          submitObj.publicvege =  musor.publicVege;
          submitObj.alkalomentities = alkalmak;

          Services.editMusorAlkalmak(submitObj, (err, res) => {
            if (!err) {
              this.props.globals.addSuccess('Műsor módosítva!');
              this.toggleDoubleFormModal();
              this.listMusor();
              let jegySelect = {};
              let selectedJegyek = {};
              Object.keys(res[0].jegyek).forEach(szektor => {
                jegySelect[szektor] = Object.keys(res[0].jegyek[szektor]).map(j => { return {nev: j, arkategoriaKod: szektor}});
                selectedJegyek[szektor] = [];
              });
              this.setState({
                currentId: musor.id,
                jegySelectJson : res[0].jegyek,
                jegySelectArray : jegySelect,
                savedAlkalmak : res[0].alkalomIds,
                selectedJegyek: selectedJegyek,
              }, ()=> this.toggleJegySelectModal());
            }
          });
          this.setState({
            saveButtonLoading: false
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    });
  }

  saveAlkalmak = () => {
    const {
      currentId,
      formAlkalmak,
      formTeremkiosztas,
      formTerem,
      baseJson,
      jegySWExists
    } = this.state;
    this.setState({
      alkalmakFormButtonLoading: true
    }, () => {
      let submitObj = {};
      
      formAlkalmak.forEach(alkalom => {
        alkalom.teremkiosztasKod = jegySWExists ? formTeremkiosztas && formTeremkiosztas.kod : null;
        alkalom.teremkiosztasNev = jegySWExists ? formTeremkiosztas && formTeremkiosztas.nev : null;
        alkalom.teremId = !jegySWExists ? formTerem && formTerem.id : formTeremkiosztas ?  formTeremkiosztas.teremId : null;
        alkalom.esemenyKezdete = alkalom.esemenyKezdete && TimeFormatter.formatIso(alkalom.esemenyKezdete);
        alkalom.esemenyVege = alkalom.esemenyVege && TimeFormatter.formatIso(alkalom.esemenyVege);
        alkalom.foglalasKezdete = alkalom.foglalasKezdete && TimeFormatter.formatIso(alkalom.foglalasKezdete);
        alkalom.foglalasVege = alkalom.foglalasVege && TimeFormatter.formatIso(alkalom.foglalasVege);
        alkalom.vasarlasKezdete = alkalom.vasarlasKezdete && TimeFormatter.formatIso(alkalom.vasarlasKezdete);
        alkalom.vasarlasVege = alkalom.vasarlasVege && TimeFormatter.formatIso(alkalom.vasarlasVege);
        alkalom.penznemId = alkalom.penznem?.id;
        alkalom.kenyelmidij = alkalom.kenyelmidij && Number(alkalom.kenyelmidij);
        alkalom.kenyelmidijsz = alkalom.kenyelmidijsz && Number(alkalom.kenyelmidijsz);
      });

      const musor = baseJson.find( m => m.id === currentId);
      submitObj.id = currentId;
      submitObj.eloadasid = musor.eloadasId;
      submitObj.helyszinid = musor.helyszinId;
      submitObj.publickezdete =  musor.publicKezdete;
      submitObj.publicvege =  musor.publicVege;
      submitObj.alkalomentities = formAlkalmak;

      Services.editMusorAlkalmak(submitObj, (err, res) => {
        if (!err) {
          this.props.globals.addSuccess('Műsor módosítva!');
          this.toggleAlkalmakModal();
          this.listMusor();
          let jegySelect = {};
          let selectedJegyek = {};
          Object.keys(res[0].jegyek).forEach(szektor => {
            jegySelect[szektor] = Object.keys(res[0].jegyek[szektor]).map(j => { return {nev: j, arkategoriaKod: szektor}});
            selectedJegyek[szektor] = [];
          });
          this.setState({
            alkalmakFormButtonLoading: false,
            jegySelectJson : res[0].jegyek,
            jegySelectArray : jegySelect,
            savedAlkalmak : res[0].alkalomIds,
            selectedJegyek: selectedJegyek,
          }, ()=> { if(Object.keys(this.state.jegySelectArray).length > 0) this.toggleJegySelectModal()});
        } else {
          this.setState({
            alkalmakFormButtonLoading: false
          });
        }
      });
    });
  }

  saveCsoportos = () => {
    const {
      currentId,
      formIdopontok,
      selectedDays,
      formTerem,
      formTeremkiosztas,
      formTulajdonsag,
      formPenznem,
      formEsemenyTipus,
      formPublikus,
      formMaxjegyszam,
      formKenyelmidij,
      formKenyelmidijsz,
      formRendelesIdoLimit,
      formRendelesTorlesIdoLimit,
      formEloadasIdotartam,
      baseJson,
      jegySWExists
    } = this.state;

    const foglalhato = formEsemenyTipus ? formEsemenyTipus.nam.includes("FOGLALHATO") : false;
    const vasarolhato = formEsemenyTipus ? formEsemenyTipus.nam.includes("VASAROLHATO") : false;

    if (!selectedDays || selectedDays.length === 0 || !formIdopontok || formIdopontok.length === 0){
      this.props.globals.addError("Dátum és időpont megadása kötelező!");
    } else {
      this.setState({
        csoportosFormButtonLoading: true
      }, () => {
        let submitObj = {};
        let alkalmak = [];
        selectedDays.forEach(day => {
          formIdopontok && formIdopontok.forEach(time => {
            const now = new Date();
            const dayParts = day.split('-');
            const timeParts = time.label.split(':');
            let kezdete = new Date(dayParts[0], dayParts[1] - 1, dayParts[2], timeParts[0], timeParts[1], 0);
            let vege = new Date(kezdete.getTime() + (formEloadasIdotartam * 60000));
            let vasarlasKezdete =  now;
            let vasarlasVege = new Date(kezdete.getTime() - (10 * 60000));
            let foglalasKezdete = now;
            let foglalasVege = new Date(kezdete.getTime() - (30 * 60000));

            let alkalom = {};
            alkalom.teremkiosztasKod = jegySWExists ? formTeremkiosztas && formTeremkiosztas.kod : null;
            alkalom.teremkiosztasNev = jegySWExists ? formTeremkiosztas && formTeremkiosztas.nev : null;
            alkalom.teremId = !jegySWExists ? formTerem && formTerem.id : formTeremkiosztas ?  formTeremkiosztas.teremId : null;
            alkalom.esemenyTipus = formEsemenyTipus;
            alkalom.tulajdonsagEntity = formTulajdonsag;
            alkalom.penznemId = formPenznem?.id;
            alkalom.publikus = formPublikus;
            alkalom.maxjegyszam = formMaxjegyszam;
            alkalom.kenyelmidij = formKenyelmidij;
            alkalom.kenyelmidijsz = formKenyelmidijsz;
            alkalom.rendelesIdoLimit = formRendelesIdoLimit;
            alkalom.rendelesTorlesIdoLimit = formRendelesTorlesIdoLimit;

            alkalom.esemenyKezdete = TimeFormatter.formatIso(kezdete);
            alkalom.esemenyVege =  TimeFormatter.formatIso(vege);
            alkalom.foglalasKezdete = foglalhato ? TimeFormatter.formatIso(foglalasKezdete) : null;
            alkalom.foglalasVege =  foglalhato ? TimeFormatter.formatIso(foglalasVege) : null;
            alkalom.vasarlasKezdete =   vasarolhato ? TimeFormatter.formatIso(vasarlasKezdete) : null;
            alkalom.vasarlasVege = vasarolhato ? TimeFormatter.formatIso(vasarlasVege) : null;

            alkalmak.push(alkalom);
          });
        });

        const musor = baseJson.find( m => m.id === currentId);
        submitObj.id = currentId;
        submitObj.eloadasid = musor.eloadasId;
        submitObj.helyszinid = musor.helyszinId;
        submitObj.publickezdete =  musor.publicKezdete;
        submitObj.publicvege =  musor.publicVege;
        submitObj.alkalomentities = alkalmak;

        Services.editMusorAlkalmak(submitObj, (err, res) => {
          if (!err) {
            this.props.globals.addSuccess('Műsor módosítva!');
            this.toggleCsoportosModal();
            this.listMusor();
            let jegySelect = {};
            let selectedJegyek = {};
            
            Object.keys(res[0].jegyek).forEach(szektor => {
              jegySelect[szektor] = Object.keys(res[0].jegyek[szektor]).map(j => { return {nev: j, arkategoriaKod: szektor}});
              selectedJegyek[szektor] = [];
            });
            this.setState({
              csoportosFormButtonLoading: false,
              jegySelectJson : res[0].jegyek,
              jegySelectArray : jegySelect,
              savedAlkalmak : res[0].alkalomIds,
              selectedJegyek: selectedJegyek,
            }, ()=> { if(Object.keys(this.state.jegySelectArray).length > 0) this.toggleJegySelectModal()});
          } else {
            this.setState({
              csoportosFormButtonLoading: false
            });
          }
        });
      });
    }
  }

  saveSelectedJegyek = () => {
    const {
      currentId,
      jegySelectJson,
      selectedJegyek,
      savedAlkalmak,
      jegySWExists
    } = this.state;
    this.setState({
      jegySelectButtonLoading: true
    }, () => {
      const filtered = {};
      Object.keys(jegySelectJson).forEach(szektor => {
        filtered[szektor] = {};
        Object.keys(jegySelectJson[szektor]).forEach( jegy => {
          if(selectedJegyek[szektor].includes(jegy)){
            filtered[szektor][jegy] = jegySelectJson[szektor][jegy];
          }
        });
      });
      Services.saveSelectedJegyek(currentId, { alkalomIds: savedAlkalmak, jegyek: filtered } , (err) => {
        if (!err) {
          this.props.globals.addSuccess('Jegyárak hozzáadva!');
          this.toggleJegySelectModal();
          this.listMusor();
          this.setState({
            jegySelectButtonLoading: false
          }, () => {
            setTimeout(() => {
              document.body.style.overflow = 'auto';
              document.body.style.paddingRight = '0';
            }, 500);
          });
        } else {
          this.setState({
            jegySelectButtonLoading: false
          });
        }
      });
    });
  }

  atadasAlkalmak = () => {
    const {
      currentId,
      baseJson,
      currentAlkalomId,
      formTerem,
      formTeremkiosztas,
      formAzonosito,
      formEsemenyKezdete,
      formEsemenyVege,
      formFoglalasKezdete,
      formFoglalasVege,
      formVasarlasKezdete,
      formVasarlasVege,
      formEsemenyTipus,
      formPublikus,
      formMaxjegyszam,
      formKenyelmidij,
      formKenyelmidijsz,
      formRendelesIdoLimit,
      formRendelesTorlesIdoLimit,
      formTulajdonsag,
      formPenznem,
    } = this.state;
    this.setState({
      alkalomAtadasButtonLoading: true
    }, () => {
      let submitObj = {};
      let musor = baseJson.find( m => m.id === currentId);
      delete musor.alkalomentities;
      submitObj.id = currentAlkalomId;
      submitObj.musor = musor;
      submitObj.teremkiosztasKod = formTeremkiosztas ? formTeremkiosztas.kod : null;
      submitObj.teremkiosztasNev = formTeremkiosztas ? formTeremkiosztas.nev : null;
      submitObj.teremId = !formTeremkiosztas ? formTerem ? formTerem.id : null : formTeremkiosztas.teremId;
      submitObj.esemenyKezdete =  formEsemenyKezdete ? TimeFormatter.formatIso(formEsemenyKezdete) : null;
      submitObj.esemenyVege =  formEsemenyVege ? TimeFormatter.formatIso(formEsemenyVege) : null;
      submitObj.foglalasKezdete =  formFoglalasKezdete ? TimeFormatter.formatIso(formFoglalasKezdete) : null;
      submitObj.foglalasVege =  formFoglalasVege ? TimeFormatter.formatIso(formFoglalasVege) : null;
      submitObj.vasarlasKezdete =  formVasarlasKezdete ? TimeFormatter.formatIso(formVasarlasKezdete) : null;
      submitObj.vasarlasVege =  formVasarlasVege ? TimeFormatter.formatIso(formVasarlasVege) : null;
      submitObj.esemenyTipus =  formEsemenyTipus;
      submitObj.publikus =  formPublikus;
      submitObj.azonosito = formAzonosito;
      submitObj.maxjegyszam = formMaxjegyszam;
      submitObj.kenyelmidij = formKenyelmidij;
      submitObj.kenyelmidijsz = formKenyelmidijsz;
      submitObj.rendelesIdoLimit = formRendelesIdoLimit;
      submitObj.rendelesTorlesIdoLimit = formRendelesTorlesIdoLimit;
      submitObj.tulajdonsagEntity = formTulajdonsag;
      submitObj.penznemId = formPenznem?.id;

      Services.atadasAlkalmak([submitObj], (err) => {
        if (!err) {
          this.props.globals.addSuccess('Alkalom átadva!');
          this.toggleFormAlkalomModal();
          this.listMusor();
          this.setState({
            alkalomAtadasButtonLoading: false
          });
        } else {
          // this.listMusor();
          this.setState({
            alkalomAtadasButtonLoading: false
          });
        }
      });
    });
  }

  handleCsoportosAtadasClick = (id) => {
    let alkalmak = [];
    this.state.baseJson.find( m => m.id == id).alkalomEntities.forEach( alkalom => {
      let newAlkalom = {};
      newAlkalom.id = alkalom.id;
      newAlkalom.musor = id;
      newAlkalom.teremkiosztasKod = alkalom.teremkiosztasKod;
      newAlkalom.teremkiosztasNev = alkalom.teremkiosztasNev;
      newAlkalom.teremId = alkalom.teremId;
      newAlkalom.esemenyKezdete =  alkalom.esemenyKezdete ? TimeFormatter.formatIso(alkalom.esemenyKezdete) : null;
      newAlkalom.esemenyVege =  alkalom.esemenyVege ? TimeFormatter.formatIso(alkalom.esemenyVege) : null;
      newAlkalom.foglalasKezdete =  alkalom.foglalasKezdete ? TimeFormatter.formatIso(alkalom.foglalasKezdete) : null;
      newAlkalom.foglalasVege =  alkalom.foglalasVege ? TimeFormatter.formatIso(alkalom.foglalasVege) : null;
      newAlkalom.vasarlasKezdete =  alkalom.vasarlasKezdete ? TimeFormatter.formatIso(alkalom.vasarlasKezdete) : null;
      newAlkalom.vasarlasVege =  alkalom.vasarlasVege ? TimeFormatter.formatIso(alkalom.vasarlasVege) : null;
      newAlkalom.esemenyTipus =  alkalom.esemenyTipus;
      newAlkalom.publikus =  alkalom.publikus;
      newAlkalom.azonosito = alkalom.azonosito;
      newAlkalom.maxjegyszam = alkalom.maxjegyszam;;
      newAlkalom.kenyelmidij = alkalom.kenyelmidij;
      newAlkalom.kenyelmidijsz = alkalom.kenyelmidijsz;
      newAlkalom.rendelesIdoLimit = alkalom.rendelesIdoLimit;
      newAlkalom.rendelesTorlesIdoLimit = alkalom.rendelesTorlesIdoLimit;
      newAlkalom.tulajdonsagEntity = alkalom.tulajdonsagEntity;
      alkalmak.push(newAlkalom);
    });

    Services.atadasAlkalmak(alkalmak, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Alkalmak átadva!');
        this.listMusor();
      } else {
        this.listMusor();
      }
    });
  }

  saveAlkalom = () => {
    const {
      currentId,
      baseJson,
      currentAlkalomId,
      formTerem,
      formTeremkiosztas,
      formAzonosito,
      formEsemenyKezdete,
      formEsemenyVege,
      formFoglalasKezdete,
      formFoglalasVege,
      formVasarlasKezdete,
      formVasarlasVege,
      formEsemenyTipus,
      formPublikus,
      formMaxjegyszam,
      formKenyelmidij,
      formKenyelmidijsz,
      formRendelesIdoLimit,
      formRendelesTorlesIdoLimit,
      formTulajdonsag,
      formPenznem
    } = this.state;
    this.setState({
      alkalomFormButtonLoading: true
    }, () => {
      let submitObj = {};
      let musor = baseJson.find( m => m.id === currentId);
      delete musor.alkalomEntities;
      submitObj.id = currentAlkalomId;
      submitObj.musor = musor;
      submitObj.teremkiosztasKod = formTeremkiosztas ? formTeremkiosztas.kod : null;
      submitObj.teremkiosztasNev = formTeremkiosztas ? formTeremkiosztas.nev : null;
      submitObj.teremId = !formTeremkiosztas ? formTerem ? formTerem.id : null : formTeremkiosztas.teremId;
      submitObj.esemenyKezdete =  formEsemenyKezdete ? TimeFormatter.formatIso(formEsemenyKezdete) : null;
      submitObj.esemenyVege =  formEsemenyVege ? TimeFormatter.formatIso(formEsemenyVege) : null;
      submitObj.foglalasKezdete =  formFoglalasKezdete ? TimeFormatter.formatIso(formFoglalasKezdete) : null;
      submitObj.foglalasVege =  formFoglalasVege ? TimeFormatter.formatIso(formFoglalasVege) : null;
      submitObj.vasarlasKezdete =  formVasarlasKezdete ? TimeFormatter.formatIso(formVasarlasKezdete) : null;
      submitObj.vasarlasVege =  formVasarlasVege ? TimeFormatter.formatIso(formVasarlasVege) : null;
      submitObj.esemenyTipus =  formEsemenyTipus;
      submitObj.publikus =  formPublikus;
      submitObj.azonosito = formAzonosito;
      submitObj.maxjegyszam = formMaxjegyszam;
      submitObj.kenyelmidij = formKenyelmidij;
      submitObj.kenyelmidijsz = formKenyelmidijsz;
      submitObj.rendelesIdoLimit = formRendelesIdoLimit;
      submitObj.rendelesTorlesIdoLimit = formRendelesTorlesIdoLimit;
      submitObj.tulajdonsagId = formTulajdonsag && formTulajdonsag.id;
      submitObj.penznemId = formPenznem?.id;

      Services.editAlkalom(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Alkalom módosítva!');
          this.toggleFormAlkalomModal();
          this.listMusor();
          this.setState({
            alkalomFormButtonLoading: false
          });
        } else {
          this.setState({
            alkalomFormButtonLoading: false
          });
        }
      });
    });
  }

  saveJegyAr = () => {
    const {
      currentAlkalomId,
      currentJegyArId,
      formTypeJegyAr,
      formJegy,
      formJegyarKategoria,
      formJegyar,
      jegySWExists,
    } = this.state;
    this.setState({
      jegyArFormButtonLoading: true
    }, () => {
      let submitObj = {};
      
      submitObj.id = currentJegyArId;
      submitObj.alkalomid = currentAlkalomId;
      submitObj.jegyid = formJegy ? formJegy.id : null;
      submitObj.arkategoriakod = jegySWExists ? (formJegyarKategoria ? formJegyarKategoria.cod : null) : formJegyarKategoria;
      submitObj.ar = formJegyar;

      if (formTypeJegyAr == 'FEL') {
        Services.addJegyAr(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Jegy ár módosítva!');
            this.toggleFormJegyArModal();
            this.listMusor();
            this.setState({
              jegyArFormButtonLoading: false
            });
          } else {
            this.setState({
              jegyArFormButtonLoading: false
            });
          }
        });
      }else if (formTypeJegyAr == 'MOD') {
        Services.editJegyAr(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Jegy ár módosítva!');
            this.toggleFormJegyArModal();
            this.listMusor();
            this.setState({
              jegyArFormButtonLoading: false
            });
          } else {
            this.setState({
              jegyArFormButtonLoading: false
            });
          }
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleChangeInput = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    
    this.setState({
      [name]: value
    });
  }

  handleDateInputChange = (e, v, name) => {
    const {
      formEloadasIdotartam,
    } = this.state;
    if (v)
      v = new Date(v);
    const value = (v === '' || isNaN(Date.parse(v))) ? null : v;
    this.setState({ [name]: value }, () => {
      switch(name){
        case 'formEsemenyKezdete':
          let vege = null;
          let foglalasVege = null;
          let vasarlasVege = null;
          if (value) {
            vasarlasVege = new Date(value.getTime() - (10 * 60000));
            foglalasVege = new Date(value.getTime() - (30 * 60000));
            if (formEloadasIdotartam) {
              vege = new Date(value.getTime() + (formEloadasIdotartam * 60000));
            }}
          this.setState({ formEsemenyVege: vege , formVasarlasVege: vasarlasVege, formFoglalasVege: foglalasVege});
          break;
      }
    });
  }

  handleSelectInputChange = (v, name, ignoreKenyelmiDij) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    }, async () => {
      if(name === 'formEloadas'){
        let formEloadasIdotartam = 0;
        if(value && value.id) formEloadasIdotartam = await Services.getEloadasIdotartam(value && value.id);
        this.setState({formEloadasIdotartam});
      } else if (name === 'formPenznem' && v && !ignoreKenyelmiDij && this.state.kenyelmiDijParam) {
        const kenyelmidijak = this.state.formKenyelmidijak[v?.id];
        this.setState({ formKenyelmidijsz: kenyelmidijak ? kenyelmidijak[0] : '', formKenyelmidij: kenyelmidijak ? kenyelmidijak[1] : '' });
      }
    });
  }

  handleAddIopont = (v) => {
    this.setState((prevState) => { 
      let array = prevState.formIdopontok || [];
      return { formIdopontok: [...array, v] };
    });
  }
  
  handleViewClick = (id) => {
    this.setState({
      currentId: id,
    }, () => {
      this.getMusorView(id, false);
      this.toggleViewModal();
    });
  }

  handleViewAlkalomClick = (id) => {
    this.setState({
      currentAlkalomId: id,
    }, () => {
      this.getAlkalomView(id, false);
      this.toggleViewAlkalomModal();
    });
  }

  handleNewClick = () => {
    this.setState({
      formTypeMusor: 'FEL',
      musorFormStatus: 'DATA',
      currentId: null,
      formEloadas: null,
      formPublickezdete: null,
      formPublicvege: null,   
    }, async () => {

      if(this.state.tableView === 'NORMAL'){
        this.toggleFormModal();
      }else if(this.state.tableView === 'DAYS'){
        const csoportDays = this.csoportDays();
        let  csoportosIdoOptions = [];

        for (let hIndex = 0; hIndex < 24; hIndex++) {
          for (let mIndex = 0; mIndex < 6; mIndex++) {
            csoportosIdoOptions.push({
              label: hIndex.toString().padStart(2,'0') + ':' + (mIndex * 10 ).toString().padStart(2,'0'),
              value: hIndex.toString().padStart(2,'0') + ':' + (mIndex * 10 ).toString().padStart(2,'0')
            });
          }
        }

        let rendeles = await Services.getRendelesParams();
        this.setState({
          formTeremkiosztasKod: '',
          formTeremkiosztasNev: '',
          formTerem: null,
          formTeremkiosztas: null,
          formAzonosito: '',
          formAllapot: '',
          formEsemenyKezdete: null,
          formEsemenyVege: null,
          formVasarlasKezdete: null,
          formVasarlasVege: null,
          formEsemenyTipus: null,
          formPublikus: true,
          formMaxjegyszam: '10',
          formKenyelmidij: '',
          formKenyelmidijsz: '',
          formRendelesIdoLimit: rendeles.rendelesIdoLimit,
          formRendelesTorlesIdoLimit: rendeles.rendelesTorlesIdoLimit,
          formTulajdonsag: null,
          formPenznem: null,
          selectedDays: [],
          formIdopontok: undefined,
          csoportDays: csoportDays,
          csoportosIdoOptions: csoportosIdoOptions,
          //currentAlkalomId: id,
        }, () => {
          Services.jegySWExists((err, res) => {
            if(!err){
              this.setState({jegySWExists: res[0] == true});
              this.toggleDoubleFormModal()
            }
          });
        });
      }
    });
  }

  handleEditClick = (id) => {
    this.setState({
      formTypeMusor: 'MOD',
      musorFormStatus: 'LOAD',   
      currentId: id,
    }, () => {
      this.getMusorForm(id);
      this.toggleFormModal();
    });
  }

  handleDeleteClick = (id) => {
    this.setState({
      torlesId: id
    }, () => {
      this.toggleDeleteModal();
    });
  }

  handleEditAlkalomClick = (id) => {
    this.setState({
      formTypeAlkalom: 'MOD',
      alkalomFormStatus: 'LOAD',
      formTeremkiosztasKod: '',
      formTeremkiosztasNev: '',
      formTerem: null,
      formTeremkiosztas: null,
      formAzonosito: '',
      formAllapot: '',
      formEsemenyKezdete: null,
      formEsemenyVege: null,
      formVasarlasKezdete: null,
      formVasarlasVege: null,
      formEsemenyTipus: null,
      formPublikus: null,
      formMaxjegyszam: '',
      formKenyelmidij: '',
      formKenyelmidijsz: '',
      formRendelesIdoLimit: '',
      formRendelesTorlesIdoLimit: '',
      formTulajdonsag: null,
      formPenznem: null,
      currentAlkalomId: id,
    }, () => {
      this.getAlkalomForm(id);
      this.toggleFormAlkalomModal();
    });
  }

  handleViewJegyekClick = (id) => {
    if (!this.state.expandedAlkalmak.includes(id)) {
      this.setState({
        currentAlkalomId: id,
        expandedAlkalmak: [...this.state.expandedAlkalmak, id]
      });
    } else {
      this.setState(() => ({
        currentAlkalomId: null,
        expandedAlkalmak: this.state.expandedAlkalmak.filter(x => x !== id)
      }));
    }
  }

  handleNewJegyArClick = () =>{
    this.setState({
      formTypeJegyAr: 'FEL',
      jegyArFormStatus: 'DATA',
      formJegy: null,
      formJegyarKategoria: null,
      formJegyar: '',
    }, () => this.toggleFormJegyArModal());
  }

  handleEditJegyArClick = (id) => {
    this.setState({
      formTypeJegyAr: 'MOD',
      jegyArFormStatus: 'LOAD',
      formJegy: null,
      formJegyarKategoria: null,
      formJegyar: '',
      currentJegyArId: id,
    }, () => {
      this.getJegyArForm(id);
      this.toggleFormJegyArModal();
    });
  }

  handleDeleteAlkalomClick = (id) => {
    this.setState({
      torlesAlkalomId: id
    }, () => {
      this.toggleDeleteAlkalomModal();
    });
  }

  handleDeleteJegyArClick = (id) => {
    this.setState({
      torlesJegyArId: id
    }, () => {
      this.toggleDeleteJegyArModal();
    });
  }

  handleNewAlkalmakClick = async (id) => {
    const musor = this.state.baseJson.find(m => m.id == id);
    if (this.state.kenyelmiDijParam)
      this.listKenyelmiDijak(musor.helyszinId);
    let rendeles = await Services.getRendelesParams();
    let idotartam  = 0;
    
    if(musor && musor.eloadasId){
      idotartam = await Services.getEloadasIdotartam(this.state.baseJson.find(m => m.id == id).eloadasId);
    }
    let defaultInputs = Object.assign({}, DEFAULT_ALKALOM );
    defaultInputs.rendelesIdoLimit = rendeles.rendelesIdoLimit;
    defaultInputs.rendelesTorlesIdoLimit = rendeles.rendelesTorlesIdoLimit;
    //const alkalmak = this.state.baseJson.find( m => m.id === id).alkalomEntities;

    this.setState({
      formAlkalmak: [defaultInputs],
      formHelyszin: musor.helyszin,
      formEloadasIdotartam: idotartam,
      formTeremkiosztas: null,
      //currentId: id,
      //formAlkalmak: !!alkalmak && alkalmak.length > 0 && alkalmak || [DEFAULT_ALKALOM],
    }, () => {
      Services.jegySWExists((err, res) => {
        if(!err){
          this.setState({jegySWExists: res[0] == true}, () => this.toggleAlkalmakModal());
        }
      });
    });
  }

  handleNewCsoportosClick = async (id) => {
    const csoportDays = this.csoportDays();
    let  csoportosIdoOptions = [];

    for (let hIndex = 0; hIndex < 24; hIndex++) {
      for (let mIndex = 0; mIndex < 6; mIndex++) {
        csoportosIdoOptions.push({
          label: hIndex.toString().padStart(2,'0') + ':' + (mIndex * 10 ).toString().padStart(2,'0'),
          value: hIndex.toString().padStart(2,'0') + ':' + (mIndex * 10 ).toString().padStart(2,'0')
        });
      }
    }
    let rendeles = await Services.getRendelesParams();
    let idotartam = await Services.getEloadasIdotartam(this.state.baseJson.find(m => m.id == id).eloadasId);
    if (this.state.kenyelmiDijParam)
      this.listKenyelmiDijak(this.state.baseJson.find(m => m.id == id).helyszinId);

    this.setState({
      formTeremkiosztasKod: '',
      formTeremkiosztasNev: '',
      formTerem: null,
      formTeremkiosztas: null,
      formAzonosito: '',
      formAllapot: '',
      formEsemenyKezdete: null,
      formEsemenyVege: null,
      formVasarlasKezdete: null,
      formVasarlasVege: null,
      formEsemenyTipus: null,
      formPublikus: true,
      formMaxjegyszam: '10',
      formKenyelmidij: '',
      formKenyelmidijsz: '',
      formRendelesIdoLimit: rendeles.rendelesIdoLimit,
      formRendelesTorlesIdoLimit: rendeles.rendelesTorlesIdoLimit,
      formTulajdonsag: null,
      formPenznem: null,
      selectedDays: [],
      formIdopontok: undefined,
      formEloadasIdotartam: idotartam,
      csoportDays: csoportDays,
      csoportosIdoOptions: csoportosIdoOptions,
      //currentAlkalomId: id,
    }, () => {
      Services.jegySWExists((err, res) => {
        if(!err){
          this.setState({jegySWExists: res[0] == true});
          this.toggleCsoportosModal();
        }
      });
    });
  }

  handleChangeAlkalomDateInput = (v, field, idx) => {
    const {
      formAlkalmak,
      formEloadasIdotartam,
    } = this.state;

    let value = v === '' ? null : new Date(v);
    formAlkalmak[idx][field] = value; 
    this.setState({ formAlkalmak }, () => {
      switch(field){
        case 'esemenyKezdete':
          let esemenyVege = null;
          let foglalasVege = null;
          let vasarlasVege = null;
          if(value) {
            foglalasVege = new Date(value.getTime() - (30 * 60000));
            vasarlasVege = new Date(value.getTime() - (10 * 60000));
            if (formEloadasIdotartam) {
              esemenyVege = new Date(value.getTime() + formEloadasIdotartam * 60000);
            }
          }
          formAlkalmak[idx]['foglalasVege'] = foglalasVege;
          if (formEloadasIdotartam) {
            formAlkalmak[idx]['esemenyVege']  = esemenyVege;
          }
          formAlkalmak[idx]['vasarlasVege'] = vasarlasVege;
          break;
      }
      this.setState({ formAlkalmak });
    });
  }

  handleChangeAlkalomInput = (e, v, field, idx) => {
    this.setState((prevState) => {
      let formAlkalmak = prevState.formAlkalmak;
      if (idx !== undefined) {
        formAlkalmak[idx][field] = v;
        if (field == 'penznem' && this.state.kenyelmiDijParam) {
          const kenyelmidijak = this.state.formKenyelmidijak[v?.id];
          formAlkalmak[idx].kenyelmidijsz = kenyelmidijak ? kenyelmidijak[0] : '';
          formAlkalmak[idx].kenyelmidij = kenyelmidijak ? kenyelmidijak[1] : '';
        }
      } else {
        formAlkalmak.forEach(formAlkalom => {
          formAlkalom[field] = v;
        });
        if (field == 'penznem' && this.state.kenyelmiDijParam) {
          const kenyelmidijak = this.state.formKenyelmidijak[v?.id];
          if (kenyelmidijak) {
            formAlkalmak.forEach(formAlkalom => {
              formAlkalom.kenyelmidijsz = kenyelmidijak ? kenyelmidijak[0] : '';
              formAlkalom.kenyelmidij = kenyelmidijak ? kenyelmidijak[1] : '';
            });
          }
        }
      }
      return formAlkalmak;
    });
  }

  addAlkalom = () => {
    let lastAlkalom = DEFAULT_ALKALOM;
    if(this.state.formAlkalmak && this.state.formAlkalmak.length > 0){
      lastAlkalom = this.state.formAlkalmak[this.state.formAlkalmak.length - 1];
    }
    let newAlkalom = Object.assign({}, lastAlkalom);
    delete newAlkalom.id;
    delete newAlkalom.azonosito;
    delete newAlkalom.allapot;
    delete newAlkalom.jegyAppAzonosito;
    delete newAlkalom.jegyarakEntityList;
    this.setState(prevState => ({ formAlkalmak: [...prevState.formAlkalmak, newAlkalom] }));
  }

  removeAlkalom = (idx) => {
    let formAlkalmak = this.state.formAlkalmak;
    formAlkalmak.splice(idx, 1);
    this.setState({ formAlkalmak });
  }

  csoportDays = (pDate) => {
    let datas = []; 
    const length = 7;
    for (let idx = 0; idx < length; idx++) {
      let date = pDate ? new Date(pDate.day) : new Date();
      date.setDate(date.getDate() + idx);
      datas.push({id: TimeFormatter.formatDate(date), day: date });
    }
    return datas;
  }

  compareStrings = (date1, date2)=> {
    if(date2.id === date1.id) return 0;
    else if(date1.id > date2.id) return -1;
    else if(date1.id < date2.id) return 1;
  }

  addWeek = () => {
    const {
      csoportDays,
      selectedDays
    } = this.state;

    let sortedDays = [].concat(csoportDays);
    const lastDay = sortedDays.sort((date1, date2) => this.compareStrings(date1, date2))[0];
    let lastDayPlusOne = {id: lastDay.id, day: new Date(lastDay.day)};

    lastDayPlusOne.day.setDate(lastDayPlusOne.day.getDate() + 1);
    lastDayPlusOne.id = TimeFormatter.formatDate(new Date(lastDayPlusOne.id).setDate(new Date(lastDayPlusOne.id).getDate() + 1));
    
    const newDays = this.csoportDays(lastDayPlusOne);
    const newCsoportDays = csoportDays.concat(newDays);

    let newSelectedDays = [];
    let firstDayOfTheLastWeek = new Date(lastDay.day);
    firstDayOfTheLastWeek.setDate(new Date(firstDayOfTheLastWeek).getDate() - 7);
    selectedDays.forEach(s => {
      const sDate = new Date(s);
      // Csak az utolsó hét kiválasztott napjai kerülnek átmásolásra
      if (sDate > firstDayOfTheLastWeek) {
        let newDate = sDate.setDate(sDate.getDate() + 7);
        newSelectedDays.push(TimeFormatter.formatDate(newDate));
      }
    });

    this.setState({ csoportDays: newCsoportDays, selectedDays: selectedDays.concat(newSelectedDays)});
  }

  selectDay = (selected) => {
    const {
      selectedDays
    } = this.state;

    const index = selectedDays.indexOf(selected);
    if (index < 0) {
      selectedDays.push(selected);
    } else {
      selectedDays.splice(index, 1);
    }
    this.setState({ selectedDays: [...selectedDays] });
  }

  tableIconFormatter = (cell) => {
    const atadas = this.hasRoleSpec(['MUSOR_ATADAS'])
    return (
      <div>
        <React.Fragment>
          <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekint'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if(e) e.preventDefault() }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'megtekint'} delay={50}>
            {'Megtekintés'}
          </UncontrolledTooltip>
        </React.Fragment>
        {this.hasRole(['MUSOR_MUSOR'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if(e)  e.preventDefault()  }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip>

            <Button className="icon-film table-action-icon" id={'action-view-' + cell + 'ujalkalom'} onClick={(e) =>  this.handleNewAlkalmakClick(cell)} onMouseDown={(e) => { if(e)  e.preventDefault()  }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'ujalkalom'} delay={50}>
              {'Alkalmak hozzáadása'}
            </UncontrolledTooltip>

            <Button className="icon-calendar table-action-icon" id={'action-view-' + cell + 'csoportos'} onClick={(e) =>  this.handleNewCsoportosClick(cell)} onMouseDown={(e) => { if(e)  e.preventDefault()  }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'csoportos'} delay={50}>
              {'Csoportos időpont hozzáadás'}
            </UncontrolledTooltip>

            {atadas && (
              <React.Fragment>
                <Button className="icon-rocket table-action-icon" id={'action-view-' + cell + 'csoportos-atadas'} onClick={(e) =>  this.handleCsoportosAtadasClick(cell)} onMouseDown={(e) => { if(e)  e.preventDefault()  }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'csoportos-atadas'} delay={50}>
                  {'Csoportos átadás'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}

            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'delete'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if(e) e.preventDefault()}} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'delete'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  tableIconFormatterAlkalom = (cell) => {
    return (
      <div>
        <React.Fragment>
          <Button
            className="icon-eye table-action-icon"
            id={'action-view-' + cell + '-alk-megtekint'}
            onClick={() => this.handleViewAlkalomClick(cell)}
            onMouseDown={(e) => { if(e) e.preventDefault() }}
          />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-alk-megtekint'} delay={50}>
            {'Megtekintés'}
          </UncontrolledTooltip>
        </React.Fragment>
        {this.hasRole(['MUSOR_MUSOR'], true) && (
          <React.Fragment>
            <Button
              className="icon-pencil table-action-icon"
              id={'action-view-' + cell + '-alk-modositas'}
              onClick={() => this.handleEditAlkalomClick(cell)}
              onMouseDown={(e) => { if(e)  e.preventDefault() }}
              />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-alk-modositas'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip>
            <Button
              className="icon-trash table-action-icon"
              id={'action-view-' + cell + '-alk-delete'}
              onClick={() => this.handleDeleteAlkalomClick(cell)}
              onMouseDown={(e) => { if(e) e.preventDefault()}}
              />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-alk-delete'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          {this.state.tableView === 'DAYS' && (
            <React.Fragment>
              <Button
                className="icon-wallet table-action-icon"
                id={'action-view-' + cell + '-jegyek'}
                onClick={() => this.handleViewJegyekClick(cell)}
                onMouseDown={(e) => { if(e)  e.preventDefault() }}
                />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-jegyek'} delay={50}>
                {'Jegyárak'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
          </React.Fragment>
        )}
      </div>
    );
  }

  tableIconFormatterJegyArak = (cell) => {
    return (
      <div>
        {this.hasRole(['MUSOR_MUSOR'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + '-jegy-modositas'} onClick={() => this.handleEditJegyArClick(cell)} onMouseDown={(e) => { if(e)  e.preventDefault()  }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-jegy-modositas'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + '-jegy-delete'} onClick={() => this.handleDeleteJegyArClick(cell)} onMouseDown={(e) => { if(e) e.preventDefault()}} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-jegy-delete'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  dateColumnFormatter = (cell) => {
    let date = cell.split('|');
    return (
      <React.Fragment>
        <div style={{ whiteSpace: 'normal' }}>
          {date[0]}
        </div>
        <div style={{ whiteSpace: 'normal' }}>
          {date[1]}
        </div>
      </React.Fragment>
    )
  }

  renderView = () => {
    const {
      viewMusor
    } = this.state;

    return (
      <div>
        <h6>Műsor:</h6>
        <b>Előadás: </b>
        {viewMusor && viewMusor.eloadas && viewMusor.eloadas.cim}
        <br />
        <b>Helyszín: </b>
        {viewMusor && viewMusor.helyszin && viewMusor.helyszin.nev}
        <br />
        <b>Publikálás kezdete: </b>
        {viewMusor && viewMusor.publicKezdete ? TimeFormatter.formatDateTimeWithoutSeconds(viewMusor.publicKezdete) : ""}
        <br />
        <b>Publikálás vége: </b>
        {viewMusor && viewMusor.publicVege ? TimeFormatter.formatDateTimeWithoutSeconds(viewMusor.publicVege): ""}
      </div>
    );
  }

  renderAlkalomView = () => {
    const {
      jegySWExists,
      viewAlkalom
    } = this.state;

    return (
      <div>
        <h6>Alkalom:</h6>
        <b>Azonosító: </b>
        {viewAlkalom && viewAlkalom.azonosito}
        <br />
        <b>Állapot: </b>
        {viewAlkalom && viewAlkalom.allapot && viewAlkalom.allapot.caption}
        <br />
        <b>Terem: </b>
        {viewAlkalom && viewAlkalom.terem && viewAlkalom.terem.azonosito}
        <br />
        <b>Előadás kezdete: </b>
        {viewAlkalom && TimeFormatter.formatDateTimeWithoutSeconds(viewAlkalom.esemenyKezdete)}
        <br />
        <b>Előadás vége: </b>
        {viewAlkalom && TimeFormatter.formatDateTimeWithoutSeconds(viewAlkalom.esemenyVege)}
        <br />
        <b>Foglalás kezdete: </b>
        {viewAlkalom && viewAlkalom.foglalasKezdete && TimeFormatter.formatDateTimeWithoutSeconds(viewAlkalom.foglalasKezdete)}
        <br />
        <b>Foglalás vége: </b>
        {viewAlkalom && viewAlkalom.foglalasVege && TimeFormatter.formatDateTimeWithoutSeconds(viewAlkalom.foglalasVege)}
        <br />
        <b>Értékesítés kezdete: </b>
        {viewAlkalom && viewAlkalom.vasarlasKezdete && TimeFormatter.formatDateTimeWithoutSeconds(viewAlkalom.vasarlasKezdete)}
        <br />
        <b>Értékesítés vége: </b>
        {viewAlkalom && viewAlkalom.vasarlasVege && TimeFormatter.formatDateTimeWithoutSeconds(viewAlkalom.vasarlasVege)}
        <br />
        <b>Maximum jegyszám: </b>
        {viewAlkalom && viewAlkalom.maxjegyszam}
        <br />
        <b>Pénznem: </b>
        {viewAlkalom && viewAlkalom.penznem?.azonosito}
        <br />
        <b>Kényelmi díj összege: </b>
        {viewAlkalom && viewAlkalom.kenyelmidij}
        <br />
        <b>Kényelmi díj %: </b>
        {viewAlkalom && viewAlkalom.kenyelmidijsz}
        <br />
        <b>Esemény típusa: </b>
        {viewAlkalom && viewAlkalom.esemenyTipus && viewAlkalom.esemenyTipus.cap}
        <br />
        <b>Publikus: </b>
        {viewAlkalom && viewAlkalom.publikus ? 'Igen' : 'Nem'}
        <br />
        <b>Rendelés időlimit (perc): </b>
        {viewAlkalom && viewAlkalom.rendelesIdoLimit}
        <br />
        <b>Rendelés törlés időlimit (perc): </b>
        {viewAlkalom && viewAlkalom.rendelesTorlesIdoLimit}
        <br />
        {jegySWExists &&
          <React.Fragment>
            <b>Jegyszoftver azonosító: </b>
            {viewAlkalom && viewAlkalom.jegyAppAzonosito}
          </React.Fragment>
        }
      </div>
    );
  }

  renderTable = () => {
    const options = {
      sizePerPage: 50,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
      ],
    };

    const selectRow = {
      mode: 'radio',
      clickToSelect: true,
      selected: this.state.selectedMusor,
      onSelect: this.onRowMusorSelect,
    };

    const columns = [
      {
        dataField: 'eloadas.cim',
        text: 'Előadás címe',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'helyszin.nev',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'publicPeriod',
        text: 'Publikálás',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          selectRow={selectRow}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  renderNapokTable = () => {
    const options = {
      sizePerPage: 10,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
      ],
    };

    const rowStyle = (row) => {
      const {allapot} = row;
      switch(allapot.name){
        case "FELVITT" : break;
        case "ATADOTT" : return { backgroundColor: '#e8d568'}; 
        case "MODATADOTT" : return { backgroundColor: '#e39932'};
        case "SIKERES" : return { backgroundColor: '#5bd887'}; 
        default: return;
      }
    };

    const columns = [
      {
        dataField: 'eloadasCim',
        text: 'Előadás címe',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'eloadasIdotartam',
        text: 'Időtartam',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        formatter: cell => cell + ' perc'
      },
      {
        dataField: 'helyszinNev',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'terem.nev',
        text: 'Terem',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'tulajdonsagEntity.megjelenes',
        text: 'Tulajdonság',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'esemenyPeriod',
        text: 'Előadás',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: this.dateColumnFormatter
      },
      {
        dataField: 'vasarlasPeriod',
        text: 'Értékesítés',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: this.dateColumnFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatterAlkalom
      }
    ];

    const jegyColumns = [
      {
        dataField: 'jegyNev',
        text: 'Jegy',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      },
      {
        dataField: 'arkategoriaKod',
        text: 'Árkategória',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      },
      {
        dataField: 'ar',
        text: 'Ár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: true,
        formatter: this.tableIconFormatterJegyArak
      }
    ];

    const expandRow = {
      renderer: row => (row.jegyarakEntityList ?
        (
          <React.Fragment>
            <h5>Jegyárak:</h5>
            <BootstrapTable
              bootstrap4
              keyField="id"
              data={row.jegyarakEntityList}
              columns={jegyColumns}
              filter={filterFactory()}
              pagination={paginationFactory(Lib.bootstraptableProps)}
              noDataIndication="Nincs megjelenítendő adat!"
            />
          </React.Fragment>
        )
        : null
      ),
      expanded: this.state.expandedAlkalmak,
      expandByColumnOnly: true
    };
    
    return (Object.keys(this.state.baseJsonDays).map(day =>
      <div className="row" key={day} style={{padding: 10}}>
        <div className="card">
          <div className="card-header">
            <h6 style={{textAlign: 'center'}}>{TimeFormatter.format(day, 'LL')}</h6>
          </div>  
          <div className="animated fadeIn">
            <BootstrapTable
              bootstrap4
              keyField="id"
              data={this.state.baseJsonDays[day]}
              columns={columns}
              rowStyle={rowStyle}
              expandRow={expandRow}
              filter={filterFactory()}
              pagination={paginationFactory(Lib.bootstraptableProps)}
              noDataIndication="Nincs megjelenítendő adat!"
            />
          </div>
        </div>
      </div>
    ));
  }

  renderAlkalmakTable = () => {
    const options = {
      sizePerPage: 50,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
      ],
    };

    const selectRow = {
      mode: 'radio',
      clickToSelect: true,
      selected: this.state.selectedAlkalom,
      onSelect: this.onRowAlkalomSelect,
    };

    const rowStyle = (row) => {
      const {allapot} = row;
      switch(allapot.name){
        case "FELVITT" : break;
        case "ATADOTT" : return { backgroundColor: '#e8d568'};
        case "MODATADOTT" : return { backgroundColor: '#e39932'};
        case "SIKERES" : return { backgroundColor: '#5bd887'}; 
        default: return;
      }
    };

    const selectType = {
      'true': 'Igen',
      'false': 'Nem',
    };
    
    const columns = [
      {
        dataField: 'terem.nev',
        text: 'Terem',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          background: 'transparent'
        },
        sort: true
      },
      {
        dataField: 'tulajdonsagEntity.megjelenes',
        text: 'Tulajdonság',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          background: 'transparent'
        },
        sort: true
      },
      {
        dataField: 'esemenyPeriod',
        text: 'Előadás',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
          background: 'transparent'
        },
        sort: true,
        formatter: this.dateColumnFormatter
        //formatter: cell => <Badge color="primary">{cell}</Badge>
      },
      {
        dataField: 'vasarlasPeriod',
        text: 'Értékesítés',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
          background: 'transparent'
        },
        sort: true,
        formatter: this.dateColumnFormatter
      },
      {
        dataField: 'maxjegyszam',
        text: 'Max. jegyszám',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          background: 'transparent'
        },
        sort: true,
      },
      {
        dataField: 'esemenyTipus.cap',
        text: 'Esemény típusa',
        filter: selectFilter({
          options: this.state.esemenyTipusOptions, 
          placeholder: 'Összes',
        }),
        style: {
          whiteSpace: 'pre-line',
          background: 'transparent'
        },
        sort: true,
      },
      {
        dataField: 'publikus',
        text: 'Publikus',
        filter: selectFilter({
          options: selectType, 
          placeholder: 'Összes',
        }),
        style: {
          whiteSpace: 'pre-line',
          background: 'transparent'
        },
        sort: true,
        formatter: cell => cell ? "Igen" : "Nem",
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        style: {
          background: 'transparent'
        },
        formatter: this.tableIconFormatterAlkalom
      }
    ];

    return this.state.alkalmakJson && this.state.alkalmakJson.length > 0 &&
      (
        <React.Fragment>
          <h5>Alkalmak: </h5>
          <div className="animated fadeIn">
            <BootstrapTable
              bootstrap4
              keyField="id"
              data={this.state.alkalmakJson}
              columns={columns}
              rowStyle={rowStyle}
              filter={filterFactory()}
              pagination={paginationFactory(Lib.bootstraptableProps)}
              selectRow={selectRow}
              noDataIndication="Nincs megjelenítendő adat!"
            />
          </div>
        </React.Fragment>
      );
  }

  renderJegyarakTable = () => {
    const options = {
      sizePerPage: 25,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
      ],
    };

    const columns = [
      {
        dataField: 'jegyNev',
        text: 'Jegy',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      },
      {
        dataField: 'arkategoriaKod',
        text: 'Árkategória',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      },
      {
        dataField: 'ar',
        text: 'Ár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        formatter: (cell, row, rowIdx, formatExtraData) => cell + ' ' + formatExtraData,
        formatExtraData: this.state.currentAlkalomPenznemAzon,
        sort: true,
      },
      {
        dataField: 'id',
        hidden: !this.hasRole(['MUSOR_MUSOR'], true),
        text: 'Műveletek',
        formatter: this.tableIconFormatterJegyArak
      }
    ];

    return (this.state.jegyArTable &&
        <React.Fragment>
          <span>
            <span className="h5">Jegyárak: </span>
            {this.hasRole(['MUSOR_MUSOR'], true) && (
              <Button className="table-new-button" color="primary" onClick={this.handleNewJegyArClick}>
                {'Új Jegyár'}
              </Button>
            )}
          </span>
          {this.state.jegyarakJson && this.state.jegyarakJson.length > 0 &&
            <div className="animated fadeIn">
              <BootstrapTable
                bootstrap4
                keyField="id"
                data={this.state.jegyarakJson}
                columns={columns}
                filter={filterFactory()}
                pagination={paginationFactory(Lib.bootstraptableProps)}
                noDataIndication="Nincs megjelenítendő adat!"
              />
            </div>
          }
        </React.Fragment>
      );
  }

  renderJegySelectTable = () => {
    const {
      jegySelectArray
    } = this.state;

    const selectRow = (szektor) => {
      return {
        mode: 'checkbox',
        selected: this.state.selectedJegyek[szektor],
        onSelect: this.onRowJegySelect,
        onSelectAll: this.onRowJegySelectAll,
      };
    }

    const options = {
      sizePerPage: 25,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
      ],
    };

    const columns = [
      {
        dataField: 'nev',
        text: 'Jegy',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      }
    ];

    return (
      Object.keys(this.state.jegySelectArray).map(szektor =>
        <div className="row" key={szektor} style={{padding: 10}}>
          <div className="card">
            <div className="card-header">
              <h6 style={{textAlign: 'center'}}>{szektor}</h6>
            </div>
            {this.state.jegySelectArray[szektor] && 
              <div className="animated fadeIn" style={{ padding: 10 }}>
                <BootstrapTable
                  bootstrap4
                  keyField="nev"
                  data={jegySelectArray[szektor]}
                  columns={columns}
                  filter={filterFactory()}
                  pagination={paginationFactory(Lib.bootstraptableProps)}
                  selectRow={selectRow(szektor)}
                  noDataIndication="Nincs megjelenítendő adat!"
                />
              </div>
            }
          </div>
        </div>
      )
    );
  }

  renderTableView = () => {
    return({
      NORMAL:  
      (<div>
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.listMusor()}
          />),
          TABL: (this.renderTable())
        }[this.state.tableStatus]}
      </div>),
      DAYS:
      (<div>
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.listMusor()}
          />),
          TABL: (this.renderNapokTable())
        }[this.state.tableStatus]}
      </div>)
    }[this.state.tableView]
    );
  }

  renderModals = () => {
    const {
      currentId,
      currentAlkalomId,
      selectedAlkalom, 
      selectedMusor,
      currentJegyArId,
      musorViewStatus,
      alkalomViewStatus,
      deleteButtonLoading,
      deleteAlkalomButtonLoading,
      deleteJegyArButtonLoading,
      formButtonLoading,
      alkalomFormButtonLoading,
      alkalomAtadasButtonLoading,
      jegyArFormButtonLoading,
      alkalmakFormButtonLoading,
      csoportosFormButtonLoading,
      jegySelectButtonLoading,
      modalFormMusor,
      modalDoubleFormMusor,
      modalFormAlkalom,
      modalFormJegyAr,
      modalDelete,
      modalAlkalomDelete,
      modalJegyArDelete,
      modalView,
      modalAlkalomView,
      modalAlkalmak,
      modalCsoportos,
      modalJegySelect,
      musorFormStatus,
      alkalomFormStatus,
      jegyArFormStatus,
      formTypeMusor,
      formTypeJegyAr,
      formEloadas,
      formHelyszin,
      formPublickezdete,
      formPublicvege,
      eloadasOptions,
      helyszinOptions
    } = this.state;
    
    const sikeresAllapot = this.state.formAllapot &&  this.state.formAllapot.name !== "SIKERES";
    const atadas = this.hasRoleSpec(['MUSOR_ATADAS']) && this.state.jegySWExists &&  sikeresAllapot;
    const helyszinId = selectedMusor && selectedMusor.length > 0 && this.state.baseJson && this.state.baseJson.find(m => selectedMusor.includes(m.id)) && this.state.baseJson.find(m => selectedMusor.includes(m.id)).helyszinId;

    return(
      <React.Fragment>
        <Modal size="lg" isOpen={modalFormMusor} toggle={this.toggleFormModal} backdrop="static">
          <RFForm
            modal
            onSubmit={this.saveMusor}
            title={formTypeMusor === 'FEL' ? 'Műsor rögzítése' : 'Műsor módosítása'}
            footer={
              <React.Fragment>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  loading={formButtonLoading}
                >
                  {'Mentés'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleFormModal}>Mégsem</Button>
              </React.Fragment>
            }
          >
            {{
              LOAD: (
                <Loader />
              ),
              NETW: (
                <NetworkEmptyState
                  hasImage
                  submitClick={() => this.getMusorForm(currentId)}
                />),
              DATA: 
                <MusorForm 
                  modositas={formTypeMusor == 'MOD'}
                  formEloadas={formEloadas}
                  formHelyszin={formHelyszin}
                  formPublickezdete={formPublickezdete}
                  formPublicvege={formPublicvege}
                  eloadasOptions={eloadasOptions}
                  helyszinOptions={helyszinOptions}
                  handleSelectInputChange={this.handleSelectInputChange}
                  handleDateInputChange={this.handleDateInputChange}
                />
            }[musorFormStatus]}
          </RFForm>
        </Modal>

        <Modal size="lg" isOpen={modalDoubleFormMusor} toggle={this.toggleDoubleFormModal} backdrop="static">
          <RFForm
            modal
            onSubmit={this.saveMusorAlkalmak}
            title={'Műsor és alkalmak rögzítése'}
            footer={
              <React.Fragment>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  loading={formButtonLoading}
                >
                  {'Mentés'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleDoubleFormModal}>Mégsem</Button>
              </React.Fragment>
            }
          >
            <div className="card">
              <div className="card-header">
                <h6>Műsor: </h6>
              </div>
              <MusorForm 
                modositas={false}
                formEloadas={formEloadas}
                formHelyszin={formHelyszin}
                formPublickezdete={formPublickezdete}
                formPublicvege={formPublicvege}
                handleSelectInputChange={this.handleSelectInputChange}
                handleDateInputChange={this.handleDateInputChange}
              />
            </div>
            <div className="card">
              <div className="card-header">
                <h6>Alkalom: </h6>
              </div>
              <CsoportosForm
                globals={this.props.globals}
                helyszinId={this.state.formHelyszin && this.state.formHelyszin.id}
                jegySWExists={this.state.jegySWExists}
                formTulajdonsag={this.state.formTulajdonsag}
                formPenznem={this.state.formPenznem}
                formTerem={this.state.formTerem}
                formTeremkiosztas={this.state.formTeremkiosztas}
                formAzonosito={this.state.formAzonosito}
                formAllapot={this.state.formAllapot}
                formEsemenyTipus={this.state.formEsemenyTipus}
                formPublikus={this.state.formPublikus}
                formMaxjegyszam={this.state.formMaxjegyszam}
                formKenyelmidij={this.state.formKenyelmidij}
                formKenyelmidijsz={this.state.formKenyelmidijsz}
                formRendelesIdoLimit={this.state.formRendelesIdoLimit}
                formRendelesTorlesIdoLimit={this.state.formRendelesTorlesIdoLimit}
                addWeek={this.addWeek}
                selectDay={this.selectDay}
                csoportDays={this.state.csoportDays}
                selectedDays={this.state.selectedDays}
                csoportosIdoOptions={this.state.csoportosIdoOptions}
                formIdopontok={this.state.formIdopontok}
                formEloadasIdotartam={this.state.formEloadasIdotartam}
                handleChangeInput={this.handleChangeInput}
                handleSelectInputChange={this.handleSelectInputChange}
                handleAddIopont={this.handleAddIopont}
                penznemOptions={this.state.penznemOptions}
                kenyelmiDijInputChecker={this.kenyelmiDijInputChecker}
              />
            </div>
          </RFForm>
        </Modal>

        <Modal size="lg" isOpen={modalFormAlkalom} toggle={this.toggleFormAlkalomModal} backdrop="static">
          <RFForm
            modal
            onSubmit={this.saveAlkalom}
            title={'Alkalom módosítása'}
            footer={
              <React.Fragment>
                { atadas &&
                  <ProgressButton
                    color="info"
                    loading={alkalomAtadasButtonLoading}
                    onClick={this.atadasAlkalmak}
                  >
                    <i class="fa fa-send" />
                    {' Átadás'}
                  </ProgressButton>
                }
                  <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    loading={alkalomFormButtonLoading}
                  >
                    {'Mentés'}
                  </ProgressButton>
                  <Button type="button" color="secondary" onClick={this.toggleFormAlkalomModal}>Mégsem</Button>
              </React.Fragment>
            }
          >
            {{
              LOAD: (
                <Loader />
              ),
              NETW: (
                <NetworkEmptyState
                  hasImage
                  submitClick={() => this.getAlkalomForm(currentAlkalomId)}
                />),
              DATA:( selectedAlkalom &&
              <AlkalomForm
                globals={this.props.globals}
                musor={selectedAlkalom && this.state.baseJson && this.state.baseJson.find(m => m.id == selectedMusor)}
                jegySWExists={this.state.jegySWExists}
                formTerem={this.state.formTerem}
                formTeremkiosztas={this.state.formTeremkiosztas}
                formAzonosito={this.state.formAzonosito}
                formAllapot={this.state.formAllapot}
                formEsemenyKezdete={this.state.formEsemenyKezdete}
                formEsemenyVege={this.state.formEsemenyVege}
                formFoglalasKezdete={this.state.formFoglalasKezdete}
                formFoglalasVege={this.state.formFoglalasVege}
                formVasarlasKezdete={this.state.formVasarlasKezdete}
                formVasarlasVege={this.state.formVasarlasVege}
                formEsemenyTipus={this.state.formEsemenyTipus}
                formPublikus={this.state.formPublikus}
                formMaxjegyszam={this.state.formMaxjegyszam}
                formKenyelmidij={this.state.formKenyelmidij}
                formKenyelmidijsz={this.state.formKenyelmidijsz}
                formRendelesIdoLimit={this.state.formRendelesIdoLimit}
                formRendelesTorlesIdoLimit={this.state.formRendelesTorlesIdoLimit}
                formTulajdonsag={this.state.formTulajdonsag}
                formPenznem={this.state.formPenznem}
                handleChangeInput={this.handleChangeInput}
                handleSelectInputChange={this.handleSelectInputChange}
                handleDateInputChange={this.handleDateInputChange}
                penznemOptions={this.state.penznemOptions}
                kenyelmiDijParam={this.state.kenyelmiDijParam}
                kenyelmiDijInputChecker={this.kenyelmiDijInputChecker}
              />)
            }[alkalomFormStatus]}
          </RFForm>
        </Modal>
        <Modal size="lg" isOpen={modalFormJegyAr} toggle={this.toggleFormJegyArModal} backdrop="static">
          <RFForm
            modal
            onSubmit={this.saveJegyAr}
            title={formTypeJegyAr === 'FEL' ? 'Jegyár rögzítése' : 'Jegyár módosítása'} 
            footer={
              <React.Fragment>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  loading={jegyArFormButtonLoading}
                >
                  {'Mentés'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleFormJegyArModal}>Mégsem</Button>
              </React.Fragment>
            }
          >
            {{
              LOAD: (
                <Loader />
              ),
              NETW: (
                <NetworkEmptyState
                  hasImage
                  submitClick={() => this.getJegyArForm(currentJegyArId)}
                />),
              DATA:
                <JegyArForm 
                  modositas={formTypeJegyAr == 'MOD'}
                  jegySWExists={this.state.jegySWExists}
                  formTeremkiosztasKod={this.state.formTeremkiosztasKod}
                  formJegy={this.state.formJegy}
                  formJegyarKategoria={this.state.formJegyarKategoria}
                  formJegyar={this.state.formJegyar}
                  handleSelectInputChange={this.handleSelectInputChange}
                  handleChangeInput={this.handleChangeInput}
                  penznemId={this.state.currentAlkalomPenznemId}
                />
            }[jegyArFormStatus]}
          </RFForm>
        </Modal>

        <Modal isOpen={modalAlkalmak} toggle={this.toggleAlkalmakModal} backdrop="static" size="lg">
          <RFForm
            modal
            onSubmit={this.saveAlkalmak}
            title={
              <React.Fragment>
                Alkalom hozzáadása
                <CustomTooltip text={getTooltip('alkalomHozzaadas')} id="alkalomHozzaadasTT" />
              </React.Fragment>
            }
            footer={
              <React.Fragment>
                <ProgressButton 
                  type='submit'
                  color="primary"
                  loading={alkalmakFormButtonLoading}
                >
                  Mentés
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleAlkalmakModal}>Mégsem</Button>
              </React.Fragment>
            }
          >
            <React.Fragment>
              <div className="row" style={{marginTop: "20px", marginBottom: "20px"}}>
                <div className="col-md-12">
                  {currentId && modalAlkalmak &&
                    <AlkalmakForm 
                      formTeremkiosztas={this.state.formTeremkiosztas}
                      formAlkalmak={this.state.formAlkalmak}
                      helyszinId={this.state.baseJson && this.state.baseJson.find(m => m.id == selectedMusor).helyszinId}
                      jegySWExists={this.state.jegySWExists}
                      handleSelectInputChange={this.handleSelectInputChange}
                      handleChangeAlkalomInput={this.handleChangeAlkalomInput}
                      handleChangeAlkalomDateInput={this.handleChangeAlkalomDateInput}
                      removeAlkalom={this.removeAlkalom}
                      penznemOptions={this.state.penznemOptions}
                      kenyelmiDijParam={this.state.kenyelmiDijParam}
                      kenyelmiDijInputChecker={this.kenyelmiDijInputChecker}
                    />
                  }
                  <Button type="button" className="btn-cursor-pointer" color="success" onClick={ e => this.addAlkalom()} >
                    Hozzáadás
                  </Button>
                </div>
              </div>
            </React.Fragment>
          </RFForm>
      </Modal>

      <Modal isOpen={modalCsoportos} toggle={this.toggleCsoportosModal} backdrop="static" size="lg">
        <RFForm
          modal
          onSubmit={this.saveCsoportos}
          title={'Alkalmak hozzáadása'}
          footer={
            <React.Fragment>
              <ProgressButton 
                color="primary"
                loading={csoportosFormButtonLoading}
              >
                Mentés
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleCsoportosModal}>Mégsem</Button>
            </React.Fragment>
          }
        >
          <React.Fragment>
            <div className="row" style={{marginTop: "20px", marginBottom: "20px"}}>
              <div className="col-md-12">
                {selectedMusor && selectedMusor.length > 0 &&
                  <CsoportosForm 
                    globals={this.props.globals}
                    helyszinId={helyszinId}
                    jegySWExists={this.state.jegySWExists}
                    formTulajdonsag={this.state.formTulajdonsag}
                    formPenznem={this.state.formPenznem}
                    formTerem={this.state.formTerem}
                    formTeremkiosztas={this.state.formTeremkiosztas}
                    formAzonosito={this.state.formAzonosito}
                    formAllapot={this.state.formAllapot}
                    formEsemenyTipus={this.state.formEsemenyTipus}
                    formPublikus={this.state.formPublikus}
                    formMaxjegyszam={this.state.formMaxjegyszam}
                    formKenyelmidij={this.state.formKenyelmidij}
                    formKenyelmidijsz={this.state.formKenyelmidijsz}
                    formRendelesIdoLimit={this.state.formRendelesIdoLimit}
                    formRendelesTorlesIdoLimit={this.state.formRendelesTorlesIdoLimit}
                    addWeek={this.addWeek}
                    selectDay={this.selectDay}
                    csoportDays={this.state.csoportDays}
                    selectedDays={this.state.selectedDays}
                    csoportosIdoOptions={this.state.csoportosIdoOptions}
                    formIdopontok={this.state.formIdopontok}
                    formEloadasIdotartam={this.state.formEloadasIdotartam}
                    handleChangeInput={this.handleChangeInput}
                    handleSelectInputChange={this.handleSelectInputChange}
                    handleAddIopont={this.handleAddIopont}
                    penznemOptions={this.state.penznemOptions}
                    kenyelmiDijParam={this.state.kenyelmiDijParam}
                    kenyelmiDijInputChecker={this.kenyelmiDijInputChecker}
                  />
                }
              </div>
            </div>
          </React.Fragment>
        </RFForm>
      </Modal>

      {/* <Modal isOpen={this.state.modalJegySelect} toggle={this.toggleJegySelectModal} backdrop="static" size="lg"> */}
            {/* {modalJegySelect && 
              this.renderJegySelectTable()
            } */}
            <RFForm
              title={'Jegyek kiválasztása'}
              modalInsert
              tagProps={{ isOpen: modalJegySelect, toggle: this.toggleJegySelectModal, backdrop: "static", size: 'lg' }}
              onSubmit={this.saveSelectedJegyek}
              footer={
                <React.Fragment>
                  <ProgressButton 
                    color="primary"
                    loading={jegySelectButtonLoading}
                  >
                    Kiválaszt
                  </ProgressButton>
                  <Button type="button" color="secondary" onClick={this.toggleJegySelectModal}>Mégsem</Button>
                </React.Fragment>
              }
            >
              {this.state.modalJegySelect && this.renderJegySelectTable()}
            </RFForm>
      {/* </Modal> */}

      <Modal isOpen={modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
        <ModalHeader>Törlés</ModalHeader>
        <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.deleteMusor()}
            loading={deleteButtonLoading}
          >
            {'Igen'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalAlkalomDelete} toggle={this.toggleDeleteAlkalomModal} backdrop="static">
        <ModalHeader>Törlés</ModalHeader>
        <ModalBody> Valóban törölni kívánod a kiválasztott tételt, és a kapcsolódó jegyárakat?</ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.deleteAlkalom()}
            loading={deleteAlkalomButtonLoading}
          >
            {'Igen'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.toggleDeleteAlkalomModal}>Mégsem</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalJegyArDelete} toggle={this.toggleDeleteJegyArModal} backdrop="static">
        <ModalHeader>Törlés</ModalHeader>
        <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.deleteJegyAr()}
            loading={deleteJegyArButtonLoading}
          >
            {'Igen'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.toggleDeleteJegyArModal}>Mégsem</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalView} toggle={this.toggleViewModal} backdrop="static">
        <ModalHeader>
          {'Megtekintés'}
        </ModalHeader>
        <ModalBody>
          {{
            LOAD: (
              <Loader />
            ),
            NETW: (
              <NetworkEmptyState
                hasImage
                submitClick={() => {}}
              />),
            DATA: (this.renderView())
          }[musorViewStatus]}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Vissza</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalAlkalomView} toggle={this.toggleViewAlkalomModal} backdrop="static">
        <ModalHeader>
          {'Megtekintés'}
        </ModalHeader>
        <ModalBody>
          {{
            LOAD: (
              <Loader />
            ),
            NETW: (
              <NetworkEmptyState
                hasImage
                submitClick={() => {}}
              />),
            DATA: (this.renderAlkalomView())
          }[alkalomViewStatus]}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewAlkalomModal}>Vissza</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
    );
  }

  render = () => {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            {this.hasRole(['MUSOR_MUSOR'], true) && (
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
                {'Új műsor'}
              </Button>
            )}
            <span className="pull-right">
              <Button className="pull-right table-new-button" color="primary" onClick={e => this.handleTableLayoutChange('DAYS')}>
                {this.state.tableView === 'NORMAL' && <i className="fa fa-calendar" />}
                {this.state.tableView === 'DAYS' && <i className="fa fa-th-list" />}
              </Button>
            </span>
          </div>
          <div className="col-md-12">
            <MusorFilters
              submit={this.listMusor}
              formFilterEloadas={this.state.formFilterEloadas}
              formFilterHelyszin={this.state.formFilterHelyszin}
              formFilterArchive={this.state.formFilterArchive}
              handleSelectInputChange={this.handleSelectInputChange}
              handleDateInputChange={this.handleDateInputChange}
              filterButtonLoading={this.state.filterButtonLoading}
            >
            </MusorFilters>
          </div>
          <div className="col-md-12">
            {this.renderTableView()}
            {this.renderAlkalmakTable()}
            {this.renderJegyarakTable()}
          </div>
        </div>
        {this.renderModals()}
      </React.Fragment>
    );
  }
}

MusorContent.propTypes = {
  globals: PropTypes.object
};

export default MusorContent;